import {Layout} from 'antd';
import './Footer.less';
import moment from 'moment';

const {Footer} = Layout;

const AppFooter = () => {
	return <Footer>© {moment().year()}, UFAR, Հայաստանում Ֆրանսիական համալսարան</Footer>;
};

export default AppFooter;
